import { HEADERS, RequestHeaders } from './RequestHeaders';
import { RequestStrategy } from './Strategy';

export interface ContactStrategyConfig {
  contactId: string;
}

export class ContactStrategy extends RequestStrategy {
  private config: ContactStrategyConfig;

  constructor(config: ContactStrategyConfig) {
    super();
    this.config = config;
  }

  public getRequestHeaders(): RequestHeaders {
    return this.buildHeaders({
      [HEADERS.CONTACT_ID]: this.config.contactId,
    });
  }
}
